export const ICONS = {
  home: {
    default: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path
          fill="#f7fcfe"
          d="m20.56 10.56-7.5-7.5c-.28-.28-.66-.44-1.06-.44s-.78.16-1.06.44l-7.5 7.5c-.14.14-.25.3-.33.49-.08.18-.11.38-.11.57v9c0 .2.08.39.22.53s.33.22.53.22h6c.2 0 .39-.08.53-.22s.22-.33.22-.53v-5.25h3v5.25c0 .2.08.39.22.53s.33.22.53.22h6c.2 0 .39-.08.53-.22s.22-.33.22-.53v-9c0-.2-.04-.39-.11-.57-.08-.18-.19-.35-.33-.49Zm-1.06 9.32H15v-5.25c0-.2-.08-.39-.22-.53s-.33-.22-.53-.22h-4.5c-.2 0-.39.08-.53.22s-.22.33-.22.53v5.25H4.5v-8.25l7.5-7.5 7.5 7.5v8.25Z"
        />
      </svg>
    ),
    active: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path
          fill="#f7fcfe"
          d="m20.56 10.56-7.5-7.5c-.28-.28-.66-.44-1.06-.44s-.78.16-1.06.44l-7.5 7.5c-.14.14-.25.3-.33.49-.08.18-.11.38-.11.57v9c0 .2.08.39.22.53s.33.22.53.22h6c.2 0 .39-.08.53-.22s.22-.33.22-.53v-5.25h3v5.25c0 .2.08.39.22.53s.33.22.53.22h6c.2 0 .39-.08.53-.22s.22-.33.22-.53v-9c0-.2-.04-.39-.11-.57-.08-.18-.19-.35-.33-.49Z"
        />
      </svg>
    ),
  },
  chat: {
    default: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path
          fill="#f7fcfe"
          d="M15.75 10.88c0 .2-.08.39-.22.53s-.33.22-.53.22H8.62c-.2 0-.39-.08-.53-.22s-.22-.33-.22-.53.08-.39.22-.53.33-.22.53-.22H15c.2 0 .39.08.53.22s.22.33.22.53ZM15 13.12H8.62c-.2 0-.39.08-.53.22s-.22.33-.22.53.08.39.22.53.33.22.53.22H15c.2 0 .39-.08.53-.22s.22-.33.22-.53-.08-.39-.22-.53-.33-.22-.53-.22ZM21.38 12c0 2.49-.99 4.87-2.75 6.63-1.76 1.76-4.14 2.75-6.63 2.75H4.12c-.4 0-.78-.16-1.06-.44s-.44-.66-.44-1.06V12c0-2.49.99-4.87 2.75-6.63C7.13 3.61 9.51 2.62 12 2.62s4.87.99 6.63 2.75c1.76 1.76 2.75 4.14 2.75 6.63Zm-1.5 0c0-2.09-.83-4.09-2.31-5.57-1.48-1.48-3.48-2.31-5.57-2.31s-4.09.83-5.57 2.31C4.95 7.91 4.12 9.91 4.12 12v7.88H12c2.09 0 4.09-.83 5.57-2.31s2.31-3.48 2.31-5.57Z"
        />
      </svg>
    ),
    active: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path
          fill="none"
          d="M15 13.12H8.62c-.2 0-.39.08-.53.22s-.22.33-.22.53.08.39.22.53.33.22.53.22H15c.2 0 .39-.08.53-.22s.22-.33.22-.53-.08-.39-.22-.53-.33-.22-.53-.22Z"
        />
        <path
          fill="#f7fcfe"
          d="M18.63 5.37C16.87 3.61 14.49 2.62 12 2.62s-4.87.99-6.63 2.75C3.61 7.13 2.62 9.51 2.62 12v7.88c0 .4.16.78.44 1.06s.66.44 1.06.44H12c2.49 0 4.87-.99 6.63-2.75s2.75-4.14 2.75-6.63-.99-4.87-2.75-6.63Zm-3.1 9.04c-.14.14-.33.22-.53.22H8.62c-.2 0-.39-.08-.53-.22s-.22-.33-.22-.53.08-.39.22-.53.33-.22.53-.22H15c.2 0 .39.08.53.22s.22.33.22.53-.08.39-.22.53Zm0-3c-.14.14-.33.22-.53.22H8.62c-.2 0-.39-.08-.53-.22s-.22-.33-.22-.53.08-.39.22-.53.33-.22.53-.22H15c.2 0 .39.08.53.22s.22.33.22.53-.08.39-.22.53Z"
        />
      </svg>
    ),
  },
  bookmark: {
    default: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path
          fill="#f7fcfe"
          d="M17.25 2.63H6.75c-.4 0-.78.16-1.06.44s-.44.66-.44 1.06v16.5c0 .13.04.27.1.38.07.12.17.21.28.28.12.06.25.1.38.09.13 0 .26-.04.38-.11l5.6-3.5 5.6 3.5c.11.07.24.11.38.11.13 0 .27-.03.38-.09.12-.06.21-.16.28-.27.07-.12.1-.25.1-.38V4.13c0-.4-.16-.78-.44-1.06s-.66-.44-1.06-.44Zm0 16.64-4.85-3.03c-.12-.07-.26-.11-.4-.11s-.28.04-.4.11l-4.85 3.03V4.13h10.5v15.15Z"
        />
      </svg>
    ),
    active: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
        <path
          d="M23 3.5H9c-.53 0-1.04.21-1.41.59-.38.38-.59.88-.59 1.41v22c0 .18.05.35.14.51.09.15.22.28.38.37.16.09.33.13.51.12.18 0 .35-.06.5-.15L16 23.68l7.47 4.67c.15.09.33.15.5.15.18 0 .35-.04.51-.13.16-.09.29-.21.38-.37.09-.15.14-.33.14-.51V5.5c0-.53-.21-1.04-.59-1.41-.38-.38-.88-.59-1.41-.59Z"
          fill="#f7fcfe"
        />
      </svg>
    ),
    gradient: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
        <defs>
          <linearGradient
            id="a"
            x1="296.96"
            x2="321.33"
            y1="-434.55"
            y2="-434.34"
            gradientTransform="matrix(1 0 0 -1 -290 -418.47)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" stopColor="#f15e25" />
            <stop offset="1" stopColor="#ce4a9b" />
          </linearGradient>
        </defs>
        <path
          d="M23 3.5H9c-.53 0-1.04.21-1.41.59-.38.38-.59.88-.59 1.41v22c0 .18.05.35.14.51.09.15.22.28.38.37.16.09.33.13.51.12.18 0 .35-.06.5-.15L16 23.68l7.47 4.67c.15.09.33.15.5.15.18 0 .35-.04.51-.13.16-.09.29-.21.38-.37.09-.15.14-.33.14-.51V5.5c0-.53-.21-1.04-.59-1.41-.38-.38-.88-.59-1.41-.59Z"
          fill="url(#a)"
        />
      </svg>
    ),
  },
  profile: {
    default: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path
          fill="#f7fcfe"
          d="M12 2.25c-1.93 0-3.81.57-5.42 1.64-1.6 1.07-2.85 2.59-3.59 4.38a9.689 9.689 0 0 0-.55 5.63c.38 1.89 1.3 3.63 2.67 4.99 1.36 1.36 3.1 2.29 4.99 2.67 1.89.38 3.85.18 5.63-.56 1.78-.74 3.3-1.99 4.38-3.59 1.07-1.6 1.64-3.49 1.64-5.42 0-2.58-1.03-5.06-2.86-6.89-1.83-1.83-4.31-2.86-6.89-2.86ZM6.95 18.52c.54-.85 1.29-1.55 2.17-2.03s1.87-.74 2.88-.74 2 .25 2.88.74 1.63 1.18 2.17 2.03c-1.45 1.12-3.22 1.73-5.06 1.73s-3.61-.61-5.05-1.73ZM9 11.25c0-.59.18-1.17.51-1.67.33-.49.8-.88 1.35-1.11.55-.23 1.15-.29 1.73-.17.58.11 1.12.4 1.54.82.42.42.71.95.82 1.54.12.58.06 1.18-.17 1.73s-.61 1.02-1.1 1.35c-.49.33-1.07.51-1.67.51-.8 0-1.56-.32-2.12-.88s-.88-1.33-.88-2.12Zm9.17 6.23c-.84-1.21-2.01-2.15-3.38-2.69.73-.58 1.27-1.37 1.53-2.27.26-.9.24-1.86-.07-2.74-.31-.88-.88-1.65-1.64-2.19-.76-.54-1.67-.83-2.61-.83s-1.85.29-2.61.83c-.76.54-1.34 1.31-1.64 2.19-.31.88-.33 1.84-.07 2.74.26.9.8 1.69 1.53 2.27-1.37.54-2.54 1.48-3.38 2.69a8.2295 8.2295 0 0 1-1.99-4.23c-.24-1.57-.02-3.18.63-4.63.65-1.45 1.71-2.68 3.04-3.55 1.34-.86 2.89-1.32 4.48-1.32s3.15.46 4.48 1.32c1.34.86 2.39 2.1 3.04 3.55.65 1.45.87 3.06.63 4.63-.24 1.57-.93 3.04-1.99 4.23Z"
        />
      </svg>
    ),
    active: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path
          fill="#f7fcfe"
          d="M12 2.25c-1.93 0-3.81.57-5.42 1.64-1.6 1.07-2.85 2.59-3.59 4.38a9.689 9.689 0 0 0-.55 5.63c.38 1.89 1.3 3.63 2.67 4.99 1.36 1.36 3.1 2.29 4.99 2.67 1.89.38 3.85.18 5.63-.56 1.78-.74 3.3-1.99 4.38-3.59 1.07-1.6 1.64-3.49 1.64-5.42 0-2.58-1.03-5.06-2.86-6.89-1.83-1.83-4.31-2.86-6.89-2.86ZM6.95 18.52c.54-.85 1.29-1.55 2.17-2.03s1.87-.74 2.88-.74 2 .25 2.88.74 1.63 1.18 2.17 2.03c-1.45 1.12-3.22 1.73-5.06 1.73s-3.61-.61-5.05-1.73ZM9 11.25c0-.59.18-1.17.51-1.67.33-.49.8-.88 1.35-1.11.55-.23 1.15-.29 1.73-.17.58.11 1.12.4 1.54.82.42.42.71.95.82 1.54.12.58.06 1.18-.17 1.73s-.61 1.02-1.1 1.35c-.49.33-1.07.51-1.67.51-.8 0-1.56-.32-2.12-.88s-.88-1.33-.88-2.12Z"
        />
      </svg>
    ),
  },
  notifications: {
    default: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path
          d="M20.79 16.49c-.52-.9-1.29-3.43-1.29-6.74 0-1.99-.79-3.9-2.2-5.3-1.41-1.41-3.31-2.2-5.3-2.2s-3.9.79-5.3 2.2c-1.41 1.41-2.2 3.31-2.2 5.3 0 3.31-.77 5.85-1.29 6.74-.13.23-.2.49-.2.75s.07.52.2.75c.13.23.32.42.55.55.23.13.49.2.75.2h3.83c.17.85.63 1.61 1.3 2.15.67.55 1.51.84 2.37.84s1.7-.3 2.37-.84c.67-.55 1.13-1.31 1.3-2.15h3.83c.26 0 .52-.07.75-.2.23-.13.42-.32.55-.55.13-.23.2-.49.2-.75s-.07-.52-.2-.75ZM12 20.25c-.47 0-.92-.14-1.3-.41-.38-.27-.67-.65-.82-1.09h4.24c-.15.44-.44.82-.82 1.09-.38.27-.83.41-1.3.41Zm-7.5-3c.72-1.24 1.5-4.12 1.5-7.5 0-1.59.63-3.12 1.76-4.24S10.41 3.75 12 3.75s3.12.63 4.24 1.76C17.37 6.64 18 8.16 18 9.75c0 3.38.78 6.26 1.5 7.5h-15Z"
          fill="#f7fcfe"
        />
      </svg>
    ),
    active: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path
          fill="#f7fcfe"
          d="M20.79 16.49c-.52-.9-1.29-3.43-1.29-6.74 0-1.99-.79-3.9-2.2-5.3-1.41-1.41-3.31-2.2-5.3-2.2s-3.9.79-5.3 2.2c-1.41 1.41-2.2 3.31-2.2 5.3 0 3.31-.77 5.85-1.29 6.74-.13.23-.2.49-.2.75s.07.52.2.75c.13.23.32.42.55.55.23.13.49.2.75.2h3.83c.17.85.63 1.61 1.3 2.15.67.55 1.51.84 2.37.84s1.7-.3 2.37-.84c.67-.55 1.13-1.31 1.3-2.15h3.83c.26 0 .52-.07.75-.2.23-.13.42-.32.55-.55.13-.23.2-.49.2-.75s-.07-.52-.2-.75ZM12 20.25c-.47 0-.92-.14-1.3-.41-.38-.27-.67-.65-.82-1.09h4.24c-.15.44-.44.82-.82 1.09-.38.27-.83.41-1.3.41Z"
        />
      </svg>
    ),
  },
  search: {
    default: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path
          fill="#f7fcfe"
          d="m21.54 20.48-4.69-4.69c1.36-1.63 2.04-3.73 1.89-5.85-.14-2.12-1.1-4.1-2.67-5.54-1.57-1.43-3.63-2.21-5.76-2.16-2.13.05-4.15.91-5.65 2.42-1.5 1.5-2.37 3.53-2.42 5.65-.05 2.13.72 4.19 2.16 5.76 1.43 1.57 3.42 2.53 5.54 2.67 2.12.14 4.22-.53 5.85-1.89l4.69 4.69c.07.07.15.12.24.16.09.04.19.06.29.06s.2-.02.29-.06c.09-.04.17-.09.24-.16s.12-.15.16-.24c.04-.09.06-.19.06-.29s-.02-.2-.06-.29c-.04-.09-.09-.17-.16-.24ZM3.76 10.51c0-1.34.4-2.64 1.14-3.75.74-1.11 1.8-1.98 3.03-2.49 1.23-.51 2.59-.64 3.9-.38s2.51.9 3.46 1.85c.94.94 1.59 2.15 1.85 3.46s.13 2.67-.38 3.9-1.38 2.29-2.49 3.03c-1.11.74-2.42 1.14-3.75 1.14-1.79 0-3.51-.71-4.77-1.98-1.27-1.27-1.98-2.98-1.98-4.77Z"
        />
      </svg>
    ),
  },
  back: {
    default: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
      >
        <path
          fill="#F7FCFF"
          d="M15.5306 18.9694a.7505.7505 0 1 1-1.0612 1.0612l-7.5-7.5a.7488.7488 0 0 1-.22-.5306.7495.7495 0 0 1 .22-.5306l7.5-7.5a.7503.7503 0 1 1 1.0612 1.0612L8.5603 12l6.9703 6.9694Z"
        />
      </svg>
    ),
  },
  heart: {
    default: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
        <path
          d="M30 11.75c0 8.75-12.97 15.83-13.53 16.12-.15.08-.31.12-.47.12s-.33-.04-.47-.12C14.98 27.58 2 20.49 2 11.75c0-2.05.82-4.02 2.27-5.48C5.72 4.82 7.69 4 9.75 4c2.58 0 4.84 1.11 6.25 2.99C17.41 5.11 19.67 4 22.25 4c2.05 0 4.02.82 5.48 2.27C29.18 7.72 30 9.69 30 11.75Z"
          fill="#f7fcfe"
        />
      </svg>
    ),
    active: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
        <path
          d="M30 11.75c0 8.75-12.97 15.83-13.53 16.12-.15.08-.31.12-.47.12s-.33-.04-.47-.12C14.98 27.58 2 20.49 2 11.75c0-2.05.82-4.02 2.27-5.48C5.72 4.82 7.69 4 9.75 4c2.58 0 4.84 1.11 6.25 2.99C17.41 5.11 19.67 4 22.25 4c2.05 0 4.02.82 5.48 2.27C29.18 7.72 30 9.69 30 11.75Z"
          fill="#f7fcfe"
        />
      </svg>
    ),
    gradient: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
        <defs>
          <linearGradient
            id="heartGradient"
            x1="0"
            y1="0"
            x2="1"
            y2="1"
            gradientUnits="objectBoundingBox"
          >
            <stop offset="0" stopColor="#f15e25" />
            <stop offset="1" stopColor="#ce4a9b" />
          </linearGradient>
        </defs>
        <path
          d="M30 11.75c0 8.75-12.97 15.83-13.53 16.12-.15.08-.31.12-.47.12s-.33-.04-.47-.12C14.98 27.58 2 20.49 2 11.75c0-2.05.82-4.02 2.27-5.48C5.72 4.82 7.69 4 9.75 4c2.58 0 4.84 1.11 6.25 2.99C17.41 5.11 19.67 4 22.25 4c2.05 0 4.02.82 5.48 2.27C29.18 7.72 30 9.69 30 11.75Z"
          fill="url(#heartGradient)"
        />
      </svg>
    ),
  },
  comment: {
    default: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
        <path
          d="M16 3.5c-3.31 0-6.49 1.32-8.83 3.67C4.83 9.51 3.51 12.69 3.5 16v10.5c0 .53.21 1.04.59 1.41.38.38.88.59 1.41.59H16c3.32 0 6.49-1.32 8.84-3.66S28.5 19.32 28.5 16s-1.32-6.49-3.66-8.84C22.5 4.82 19.32 3.5 16 3.5Zm4 16h-8.5c-.27 0-.52-.11-.71-.29s-.29-.44-.29-.71.11-.52.29-.71.44-.29.71-.29H20c.27 0 .52.11.71.29s.29.44.29.71-.11.52-.29.71-.44.29-.71.29Zm0-4h-8.5c-.27 0-.52-.11-.71-.29s-.29-.44-.29-.71.11-.52.29-.71.44-.29.71-.29H20c.27 0 .52.11.71.29s.29.44.29.71-.11.52-.29.71-.44.29-.71.29Z"
          fill="#f7fcfe"
        />
      </svg>
    ),
  },
  arrow: {
    default: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
        <path
          d="M25.71 14.71c-.09.09-.2.17-.32.22-.12.05-.25.08-.38.08s-.26-.03-.38-.08-.23-.12-.32-.22l-7.29-7.29v19.59c0 .27-.11.52-.29.71-.19.19-.44.29-.71.29s-.52-.11-.71-.29-.29-.44-.29-.71V7.41L7.73 14.7c-.19.19-.44.29-.71.29s-.52-.11-.71-.29c-.19-.19-.29-.44-.29-.71s.11-.52.29-.71l8.98-8.99c.09-.09.2-.17.32-.22.12-.05.25-.08.38-.08s.26.03.38.08.23.12.32.22l9 9c.09.09.17.2.22.32.05.12.08.25.08.38s-.03.26-.08.38-.12.23-.22.32Z"
          fill="#f7fcfe"
        />
      </svg>
    ),
  },
  dots: {
    default: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
        <path
          d="M19.5 16c0 .69-.21 1.37-.59 1.94-.38.58-.93 1.02-1.57 1.29-.64.26-1.34.33-2.02.2-.68-.14-1.3-.47-1.79-.96s-.82-1.11-.96-1.79c-.14-.68-.07-1.38.2-2.02.26-.64.71-1.19 1.29-1.57.58-.38 1.25-.59 1.94-.59.93 0 1.82.37 2.47 1.03.66.66 1.03 1.55 1.03 2.47ZM16 9.5c.69 0 1.37-.21 1.94-.59.58-.38 1.02-.93 1.29-1.57.26-.64.33-1.34.2-2.02-.14-.68-.47-1.3-.96-1.79s-1.11-.82-1.79-.96c-.68-.14-1.38-.07-2.02.2-.64.26-1.19.71-1.57 1.29-.38.58-.59 1.25-.59 1.94 0 .93.37 1.82 1.03 2.47.66.66 1.55 1.03 2.47 1.03Zm0 13c-.69 0-1.37.21-1.94.59-.58.38-1.02.93-1.29 1.57-.26.64-.33 1.34-.2 2.02.13.68.47 1.3.96 1.79s1.11.82 1.79.96c.68.14 1.38.07 2.02-.2.64-.26 1.19-.71 1.57-1.29.38-.58.59-1.25.59-1.94 0-.93-.37-1.82-1.03-2.47-.66-.66-1.55-1.03-2.47-1.03Z"
          fill="#f7fcfe"
        />
      </svg>
    ),
  },
  share: {
    default: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
        <path
          d="m29.71 16.21-10 10c-.14.14-.32.24-.51.27-.19.04-.4.02-.58-.06-.18-.08-.34-.2-.45-.37-.11-.16-.17-.36-.17-.56v-4.97c-7.14.41-12.03 5.03-13.41 6.5-.22.23-.5.39-.81.45-.31.06-.63.02-.92-.11-.29-.13-.52-.35-.68-.63-.15-.28-.22-.59-.18-.91.46-4.03 2.67-7.91 6.22-10.92 2.95-2.5 6.53-4.09 9.77-4.36V5.49c0-.2.06-.39.17-.56.11-.16.27-.29.45-.37.18-.08.38-.1.58-.06.19.04.37.13.51.27l10 10c.09.09.17.2.22.32.05.12.08.25.08.38s-.03.26-.08.38-.12.23-.22.32Z"
          fill="#f7fcfe"
        />
      </svg>
    ),
  },
  messages: {
    default: (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">
        <path
          d="M16 3.5c-3.31 0-6.49 1.32-8.83 3.67C4.83 9.51 3.51 12.69 3.5 16v10.5c0 .53.21 1.04.59 1.41.38.38.88.59 1.41.59H16c3.32 0 6.49-1.32 8.84-3.66S28.5 19.32 28.5 16s-1.32-6.49-3.66-8.84C22.5 4.82 19.32 3.5 16 3.5Zm4 16h-8.5c-.27 0-.52-.11-.71-.29s-.29-.44-.29-.71.11-.52.29-.71.44-.29.71-.29H20c.27 0 .52.11.71.29s.29.44.29.71-.11.52-.29.71-.44.29-.71.29Zm0-4h-8.5c-.27 0-.52-.11-.71-.29s-.29-.44-.29-.71.11-.52.29-.71.44-.29.71-.29H20c.27 0 .52.11.71.29s.29.44.29.71-.11.52-.29.71-.44.29-.71.29Z"
          fill="#f7fcfe"
        />
      </svg>
    ),
  },
  magnifyingGlass: {
    default: (
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M39.0612 36.9387L29.6731 27.5524C32.3941 24.2856 33.751 20.0955 33.4614 15.8538C33.1718 11.6121 31.258 7.64529 28.1182 4.77864C24.9784 1.91198 20.8543 0.366166 16.6038 0.462765C12.3533 0.559365 8.30362 2.29094 5.29728 5.29728C2.29094 8.30362 0.559365 12.3533 0.462765 16.6038C0.366166 20.8543 1.91198 24.9784 4.77864 28.1182C7.64529 31.258 11.6121 33.1718 15.8538 33.4614C20.0955 33.751 24.2856 32.3941 27.5524 29.6731L36.9387 39.0612C37.0781 39.2006 37.2435 39.3111 37.4256 39.3865C37.6077 39.462 37.8028 39.5008 37.9999 39.5008C38.197 39.5008 38.3922 39.462 38.5743 39.3865C38.7564 39.3111 38.9218 39.2006 39.0612 39.0612C39.2006 38.9218 39.3111 38.7564 39.3865 38.5743C39.462 38.3922 39.5008 38.197 39.5008 37.9999C39.5008 37.8028 39.462 37.6077 39.3865 37.4256C39.3111 37.2435 39.2006 37.0781 39.0612 36.9387ZM3.49994 16.9999C3.49994 14.3299 4.2917 11.7198 5.7751 9.49974C7.2585 7.27968 9.36691 5.54935 11.8337 4.52757C14.3005 3.50578 17.0149 3.23844 19.6337 3.75934C22.2524 4.28024 24.6579 5.56599 26.5459 7.454C28.4339 9.34201 29.7196 11.7475 30.2405 14.3662C30.7614 16.985 30.4941 19.6994 29.4723 22.1662C28.4505 24.633 26.7202 26.7414 24.5001 28.2248C22.2801 29.7082 19.67 30.4999 16.9999 30.4999C13.4207 30.496 9.98926 29.0724 7.45838 26.5415C4.9275 24.0106 3.50391 20.5791 3.49994 16.9999Z"
          fill="#B2BDC2"
        />
      </svg>
    ),
  },
  eyeOff: {
    default: (
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M35.88 35.88C32.4612 38.486 28.2982 39.9297 24 40C10 40 2 24 2 24C4.48778 19.3638 7.93827 15.3132 12.12 12.12M19.8 8.48C21.1767 8.15776 22.5861 7.99668 24 8C38 8 46 24 46 24C44.786 26.2712 43.3381 28.4095 41.68 30.38M28.24 28.24C27.6907 28.8295 27.0283 29.3023 26.2923 29.6302C25.5563 29.9582 24.7618 30.1345 23.9562 30.1487C23.1506 30.1629 22.3503 30.0148 21.6032 29.713C20.8561 29.4112 20.1774 28.9621 19.6077 28.3923C19.0379 27.8226 18.5888 27.1439 18.287 26.3968C17.9852 25.6497 17.8371 24.8494 17.8513 24.0438C17.8655 23.2382 18.0418 22.4437 18.3698 21.7077C18.6977 20.9717 19.1705 20.3093 19.76 19.76M2 2L46 46"
          stroke="#F7FCFF"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
  },
};
